import Topic from 'shared/topic';

export default class ConcurrentUsers {
  constructor(){
    this.timeout = {};
    this.animatedCounter= {};
    this.concurrentData = {};
    this.oldValue= 0;
    this.speed= 3000;
    this.$element = $('.watch-video__plays-count[data-component=ConcurrentUsers]');
    this.animateCounterActive = false;
    this.livestreamingId = this.$element.data("id");
    this.currentConcurrentData = parseInt(this.$element.text());
    this.interval = setInterval(this.processDataChange.bind(this), this.speed);
  }

  setConcurrentUserCount(data){
    this.concurrentData = data || {};
  }

  processDataChange(){
    if(typeof this.concurrentData.total_concurrent_users !== 'undefined' && this.concurrentData.total_concurrent_users !== this.currentConcurrentData){
      this.animateCounter(this.currentConcurrentData,this.concurrentData.total_concurrent_users);
      Topic.publish('livestreaming/ccu', this.concurrentData.total_concurrent_users);
    }
  }

  animateCounter(oldValue, newValue){
    var time = 2000;
    var speed = 40;
    var incrementCount = time / speed;
    var valueInterval = (newValue - oldValue) / incrementCount;

    valueInterval = valueInterval > 0 ? Math.ceil(valueInterval) : Math.floor(valueInterval);
    oldValue = parseInt(oldValue);

    if(this.animateCounterActive == false){
      this.animateCounterActive = true;
      this.animateCounterText(oldValue,newValue,valueInterval,speed);
    }
  }

  animateCounterText(oldValue, newValue, valueInterval,speed){
    if((oldValue + valueInterval) < 0)
      oldValue = 0;
    else
      oldValue += valueInterval;

    this.$element.text(this.formatted(oldValue));

    if((valueInterval > 0 && oldValue >= newValue) || (valueInterval < 0 && oldValue <= newValue) || oldValue == 0 || valueInterval == 0){
      clearTimeout(this.timeout);
      this.currentConcurrentData = oldValue;
      setTimeout(this.deactivateAnimateCounterActive.bind(this), 500);
    }else{
      this.timeout = setTimeout(this.animateCounterText.bind(this, oldValue, newValue, valueInterval, speed), speed);
    }
  }

  deactivateAnimateCounterActive(){
    this.animateCounterActive = false;
  }

  langSelected() {
    if (this.cookie() && typeof(this.cookie().split("locale=")[1]) !== "undefined") {
      return this.cookie().split("locale=")[1].split(";")[0];
    }

    return 'id';
  }

  formatted(value) {
    return new Intl.NumberFormat(this.langSelected()).format(value);
  }

  cookie() {
    return document.cookie;
  }
}
